import type { ReactNode, Ref } from "react"
import { cn } from "@/primitives/utils"

/*
 * A page's cards: one column on a phone, the page's width less its 16px gutters; two on a portrait
 * tablet (`compact:md:`), where one card the page's width would stand a long way from its few chips,
 * each pair in a row as tall as the taller. They read like text, left to right and down, so the
 * order a Status keeps runs as it does in a column.
 */
const cardList = "flex flex-col gap-2 px-4 py-3 compact:md:grid compact:md:grid-cols-2"

/**
 * The cards of one Status's page on a phone's Board, and of a lane on it, laid out as `cardList`
 * says; `id` names them for the lane's head that folds them. Its skeleton lays its blocks out the
 * same way.
 */
export function PagerCards({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <div id={id} className={cardList}>
      {children}
    </div>
  )
}

/**
 * A row laid out as PagerCards lays out its cards, but holding nothing and taking no height, whose
 * one cell `ref` measures a card's width, once for every page of the Board.
 */
export function PagerCardRuler({ ref }: { ref: Ref<HTMLDivElement> }) {
  return (
    <div aria-hidden className={cn(cardList, "invisible h-0 py-0")}>
      <div ref={ref} />
    </div>
  )
}
